export default __webpack_public_path__ + "static/media/tiana.8642ba7f.png";